import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-justificativa-vinculo-modal',
  templateUrl: './justificativa-vinculo-modal.component.html',
  styleUrls: ['./justificativa-vinculo-modal.component.scss']
})
export class JustificativaVinculoModalComponent implements OnInit {

  justificativaForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.justificativaForm = this.fb.group({
      textoJustificativa: ['']
    });
  }

  salvarObservacoes(): void {
    const textoJustificativa = this.justificativaForm.get('textoJustificativa')?.value;
    this.modalRef.close(textoJustificativa);
    }

  fecharModal(): void {
    this.modalRef.close();
  }

}
